var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-goods__price"},[_c(_vm.priceView,{tag:"component",attrs:{"state":_vm.state,"only-show-price-with-tax":_vm.onlyShowPriceWithTax}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }